import { useNavigate, useOutletContext, useParams } from 'react-router-dom';
import TemplateLayout from '../../Commons/TemplateLayout';
import { useContext, useLayoutEffect, useMemo, useState } from 'react';
import { createProjectTemplate } from '../../../../../../services/api/projectTemplates';
import { MainContext } from '../../../../../../context/MainContext';
import { useIntl } from 'react-intl';
import SuccessPage from '../../Commons/TemplateLayout/components/SuccessPage';
import { concreteTypes } from '../../../../../../constants/general';
import DeliveryFormFields from '../Commons/DeliveryFormFields';
import regionNames from '../Commons/regionNames';

const REGIONS = regionNames.map((col, index) => {
  return {
    x: 0,
    y: 0,
    width: 8,
    height: 3,
    isVisible: false,
    data: col,
    index: index,
  };
});

const CreateDeliveryTemplate = () => {
  const navigate = useNavigate();
  const intl = useIntl();
  const { project } = useOutletContext();
  const { model, id } = useParams();
  const { setError, setLoading } = useContext(MainContext);
  const [success, setSuccess] = useState(false);
  const initialData = useMemo(
    () => ({ templateName: '', supplier_id: '' }),
    [],
  );

  const createDeliveryTemplate = async (regions, formState, fileName) => {
    try {
      setLoading(true);
      const regionIndex = regions.findIndex((reg) => reg.data === 'CIF');
      const region = regions[regionIndex];
      regions.splice(regionIndex, 1);
      const newTemplate = {
        name: formState.templateName,
        supplier: formState.supplier_id,
        model: model,
        image: fileName.replace('pdf', 'png'),
        searchableRegion: {
          value: '',
          region: region,
        },
        regions: regions,
        pid: parseInt(id, 10),
      };
      const templateCreated = await createProjectTemplate(newTemplate);

      if (templateCreated.data) {
        setSuccess(true);
      }
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  };

  useLayoutEffect(() => {
    if (!concreteTypes.includes(model)) {
      navigate('/');
    }
  }, [model, navigate]);

  if (success) {
    return (
      <SuccessPage
        title={intl.formatMessage({
          id: 'pages.ocr.templates.delivery.create.success.title',
        })}
        subtitle={intl.formatMessage({
          id: 'pages.ocr.templates.delivery.create.success.subtitle',
        })}
        onBackToTemplates={() =>
          navigate(`/app/project/${project.id_project}/quality/ocr/templates`)
        }
      />
    );
  }

  return (
    <TemplateLayout
      topFormFields={<DeliveryFormFields />}
      model={model}
      initialData={initialData}
      regions={REGIONS}
      onFinish={createDeliveryTemplate}
      onBack={() =>
        navigate(`/app/project/${project.id_project}/quality/ocr/templates`)
      }
    />
  );
};

export default CreateDeliveryTemplate;
